import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import InputAdornment from '@material-ui/core/InputAdornment';

const timeList = [
    {
        value: 60,
        label: '1시간',
    },
    {
        value: 120,
        label: '2시간',
    },
    {
        value: 180,
        label: '3시간',
    },
    {
        value: 240,
        label: '4시간',
    },
    {
        value: 300,
        label: '5시간',
    },
    {
        value: 360,
        label: '6시간',
    },
    {
        value: 420,
        label: '7시간',
    },
    {
        value: 480,
        label: '8시간',
    },
    {
        value: 540,
        label: '9시간',
    },
    {
        value: 600,
        label: '10시간',
    },
    {
        value: 660,
        label: '11시간',
    },
    {
        value: 720,
        label: '12시간',
    },
    {
        value: 780,
        label: '13시간',
    },
    {
        value: 840,
        label: '14시간',
    },
    {
        value: 900,
        label: '15시간',
    },
    {
        value: 1440,
        label: '하루종일(24시간) - 퇴실불가',
    },
];

const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
    menu: {
        width: 180,
    },
}));

export default function TimeSelect(props) {
    const classes = useStyles();

    const [isSelected, setIsSelected] = React.useState(false);
    const handleChange = event => {
        if (!isSelected) {
            props.onTimeChanged(event.target.value);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);
    };

    return (
        <TextField
            id="outlined-select-currency"
            select
            label="Select"
            className={classes.textField}
            value={props.time}
            onChange={handleChange}
            SelectProps={{
                MenuProps: {
                    className: classes.menu,
                },
            }}
            margin="normal"
            variant="outlined"
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <AccessTimeIcon />
                    </InputAdornment>
                ),
            }}
        >
            {timeList.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );

}



// WEBPACK FOOTER //
// ./src/components/seat/TimeSelect.js